import HomeVideo3DX from './HomeVideo3DX';

export default HomeVideo3DX;
